import classnames from 'classnames';
import React from 'react';

const ColourSwatch = ({ facetValue, facetTypeHeader, handleChange }) => {
	if (!facetValue || !facetTypeHeader || !handleChange) {
		return null;
	}

	const facetId = `facet_${facetValue.FriendlyName}`;

	return (
		<div className="py-1 w-full">
			<a href={facetValue.Url} tabIndex="-1">
				<label
					htmlFor={`${facetTypeHeader}-${facetId}-${facetValue.Name}`}
					className="facet-type__label facet-type__label--colour-swatch c-input-checkbox flex items-center pr-2"
					data-testid="facet-type__colour-swatch">
					<input
						id={`${facetTypeHeader}-${facetId}-${facetValue.Name}`}
						type="checkbox"
						name={facetTypeHeader}
						value={facetValue.Name}
						onChange={(e) => handleChange(e)}
						onClick={(e) => handleChange(e)}
						checked={facetValue.Selected}
					/>
					<div
						className={classnames(
							'facet-type__colour-swatch facet-type__colour-swatch--rebrand h-6 w-6 border border-solid border-gray-20 rounded-sm',
							{
								[`${facetValue.FriendlyName}`]: facetValue.FriendlyName,
							}
						)}
					/>
					<div className="facet-type__label-text flex pl-2 text-body-xs text-primary">
						<span className="facet-type__label-name mr-1">
							{facetValue.Name}
						</span>{' '}
						<span className="facet-type__label-total">
							({facetValue.Total})
						</span>
					</div>
				</label>
			</a>
		</div>
	);
};

export default ColourSwatch;
